import { Outlet, Route } from "react-router";
import ErrorBoundaryEmptyState from "@Core/components/emptyStates/Error503/ErrorBoundaryEmptyState";
import ErrorBoundaryRoute from "@routes/ErrorBoundaryRoute/ErrorBoundaryRoute";
import {
  protectedLoader,
  revalidateOnPathChange,
} from "@routes/protectedLoader";
import { Roles } from "@utils/settings";
import {
  PRICING,
  PRICING_CONFIGURE,
  PRICING_SERVICE_CONFIGURE,
  YOUR_PLAN,
} from "@routes/routes";
import {
  DashboardLayout,
  ActivityHistoryPage,
  PricingPage,
  PurchaseConfiguratorPage,
  ServiceConfiguratorPage,
} from "@routes/lazyPages";

/** Routes only the clinic owner may open (plan and pricing). */
export const ownerRoutes = (
  <>
    <Route
      loader={protectedLoader([Roles.DIETITIAN_OWNER])}
      shouldRevalidate={revalidateOnPathChange}
      element={
        <ErrorBoundaryRoute>
          <Outlet />
        </ErrorBoundaryRoute>
      }
      errorElement={<ErrorBoundaryEmptyState />}
    >
      <Route lazy={DashboardLayout}>
        <Route path={YOUR_PLAN} lazy={ActivityHistoryPage} />
        <Route path={PRICING} lazy={PricingPage} />
        <Route path={PRICING_CONFIGURE} lazy={PurchaseConfiguratorPage} />
        <Route
          path={PRICING_SERVICE_CONFIGURE}
          lazy={ServiceConfiguratorPage}
        />
      </Route>
    </Route>
  </>
);
